import { create } from 'zustand';
import { useShallow } from 'zustand/shallow';
export const sendToWalletStore = create((set) => ({
    showSendToWallet: false,
    setSendToWallet: (value) => set({
        showSendToWallet: value,
    }),
}));
export const useSendToWalletStore = (selector) => {
    return sendToWalletStore(useShallow(selector));
};
export const useSendToWalletActions = () => {
    const actions = useSendToWalletStore((store) => ({
        setSendToWallet: store.setSendToWallet,
    }));
    return actions;
};
//# sourceMappingURL=useSendToWalletStore.js.map